import type { IntlShape } from "@formatjs/intl";
import { Form, Select, type SelectProps } from "antd";
import { type DefaultOptionType } from "antd/es/cascader";
import { type FormInstance, type Rule } from "antd/es/form";
import { type FilterFunc } from "rc-select/lib/Select";
import { useEffect, useMemo } from "react";
import { type Client } from "../../generated-axios-client";

const clientSelectOptions = (clientItems: Client[]) => {
  const clientOptions = clientItems.map((item) => ({
    key: item.id,
    value: item.id,
    label: item.legal_name,
  }));

  return clientOptions;
};

const clientSearchHandler: FilterFunc<DefaultOptionType> = (input, option) => {
  const search = input.toLowerCase();
  const value = option?.label?.toString().toLowerCase?.() ?? "";

  return value.includes(search);
};

type ClientSelectFormItemProps = {
  intl: IntlShape;
  clientItems: Client[];
  rules?: Rule[];
  placeholder?: string | boolean;
  selectProps?: SelectProps<string>;
  form: FormInstance;
};

export const ClientSelectorFormItem = (props: ClientSelectFormItemProps) => {
  const { intl, clientItems, rules = [], placeholder = false, selectProps, form } = props;

  const options = useMemo(() => clientSelectOptions(clientItems), [clientItems]);

  useEffect(() => {
    if (
      options.filter((item) => {
        return item.key === form.getFieldValue("client");
      }).length <= 0
    ) {
      form.setFieldValue("client", undefined);
    }
  }, [options, form]);

  return (
    <Form.Item
      name={["client"]}
      label={intl.formatMessage({ id: "filter_label_client" })}
      rules={[
        {
          required: true,
          message: intl.formatMessage({ id: "validation_message_ticket_client" }),
        },
      ]}
    >
      <Select
        placeholder={placeholder}
        allowClear={true}
        showSearch={true}
        options={options}
        filterOption={clientSearchHandler}
        {...selectProps}
      />
    </Form.Item>
  );
};
